module.exports = __webpack_public_path__ + "media/industry_tag_icon/biz_education-ac4e3aef.png";